import React from 'react'
import PropTypes from 'prop-types'

const SHORT_CODES = {
  EUR: '€',
  USD: '$',
  GBP: '£',
  CHF: 'Fr',
  CAD: 'C$',
  AUD: 'A$',
  BRL: 'R$',
  NZD: 'NZ$',
  JPY: '¥'
}

const Price = ({ price, currency, postPrice = '', dataAttr }) => {
  if (price === null || price === undefined) return null

  const numericPrice = Number(price)
  const currencyCode = SHORT_CODES[currency] || ' ' + currency
  const isWholeNumber = (numericPrice * 100) % 100 === 0
  const inFront = currencyCode.includes('$') || currencyCode === '£' || currencyCode === '¥'

  const formattedPrice = isWholeNumber ? Math.floor(numericPrice) : numericPrice.toFixed(2)

  const result = `${inFront ? currencyCode : ''}${formattedPrice}${postPrice}${inFront ? '' : currencyCode}`

  return <span data-attr={dataAttr}>{result}</span>
}

Price.propTypes = {
  price: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  currency: PropTypes.string.isRequired,
  postPrice: PropTypes.string,
  dataAttr: PropTypes.string
}

export default React.memo(
  Price,
  (prevProps, nextProps) =>
    prevProps.price === nextProps.price &&
    prevProps.currency === nextProps.currency &&
    prevProps.postPrice === nextProps.postPrice
)
